var exports = {
  "f": "ListItemTitle_0___0NtMM",
};

module.exports = exports;
